import { auth } from "./auth";

export const toast = (mensaje, type = "success") => {
    let toast = document.createElement("DIV");
    let text = document.createTextNode(mensaje);
    toast.classList.add("toast");
    toast.classList.add(type);
    toast.classList.add("animated");
    toast.classList.add("fast");
    toast.classList.add("fadeIn");
    toast.appendChild(text);
    document.getElementsByTagName("body")[0].appendChild(toast);

    setTimeout(() => {
        toast.classList.remove("fadeIn");
        toast.classList.add("fadeOut");
        setTimeout(() => {
            toast.remove();
        }, 1000);
    }, 3000);
};

export const formatCurrency = (
    amount,
    prefix = "RD$",
    decimalCount = 2,
    decimal = ".",
    thousands = ","
) => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < -0.01 ? "-" : "";

        let i = parseInt(
            (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
        ).toString();
        let j = i.length > 3 ? i.length % 3 : 0;

        return (
            negativeSign +
            prefix +
            (j ? i.substr(0, j) + thousands : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
            (decimalCount
                ? decimal +
                  Math.abs(amount - i)
                      .toFixed(decimalCount)
                      .slice(2)
                : "")
        );
    } catch (e) {
        console.log(e);
    }
};

export const formatNumber = (number) => {
    return parseFloat(number)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export const getEstadoVehiculo = (estado) => {
    const labels = getEstadosVehiculo();

    return labels[estado];
};

export const getEstadosVehiculo = () => {
    return {
        activo: "Activo",
        reparacion: "Reparación",
        inactivo: "Inactivo",
        desuso: "Desuso",
    };
};

export const isMecanico = (cargo) => {
    if (!cargo) return false;
    cargo = cargo
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();

    return cargo.indexOf("mecanico") > -1;
};

export const formatDate = (date) => {
    const parsedDate =
        Object.prototype.toString.call(date) === "date" ? date : new Date(date);

    const day = parsedDate.getDate().toString().padStart(2, 0);
    const month = (parsedDate.getMonth() + 1).toString().padStart(2, 0);
    const year = parsedDate.getFullYear();

    return `${year}-${month}-${day}`;
};

export const firstDayOfMonth = () => {
    const parsedDate = new Date();
    return formatDate(
        new Date(parsedDate.getFullYear(), parsedDate.getMonth(), 1)
    );
};

export const getMiddleDate = () => {
    const currentDate = new Date();

    if (currentDate.getDate() > 15) {
        return (
            currentDate.getFullYear() +
            "-" +
            String(currentDate.getMonth() + 1).padStart(2, "0") +
            "-" +
            "16"
        );
    } else {
        return (
            currentDate.getFullYear() +
            "-" +
            String(currentDate.getMonth() + 1).padStart(2, "0") +
            "-" +
            "15"
        );
    }
};

export const lastDayOfMonth = () => {
    const parsedDate = new Date();
    return formatDate(
        new Date(parsedDate.getFullYear(), parsedDate.getMonth() + 1, 0)
    );
};

export const getCurrentMonthName = (month) => {
    const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
    ];

    if (month === undefined) {
        return months[new Date().getMonth()];
    }

    return months[month];
};

export const getCurrentDayName = (day) => {
    const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
    ];

    return days[day];
};

export const getEstadoServicio = (estado) => {
    const estados = {
        "por-vencer": "Por vencer",
        "a-tiempo": "A tiempo",
        vencidos: "Vencidos",
        todos: "Todos",
    };

    return estados[estado];
};

export const getDiaProgramacion = (dia) => {
    const nombreAsignacionDiaria = [
        "LUNES Y JUEVES",
        "MARTES Y VIERNES",
        "MIÉRCOLES Y SÁBADOS",
        "LUNES Y JUEVES",
        "MARTES Y VIERNES",
        "MIÉRCOLES Y SÁBADOS",
        "DOMINGOS",
    ];

    return nombreAsignacionDiaria[dia];
};

export const getLink = (location) => {
    const sucursal = getSucursal();
    return `/${sucursal}${location}`;
};

export const getSucursal = () => {
    let sucursal = parseInt(document.URL.split("/")[3]);

    const user = auth.getUser();

    //Confirmar que el usuario tiene acceso a la sucursal.
    const sucursalesDisponibles = user.sucursales.filter((suc) => {
        return suc.id === sucursal;
    });

    if (!sucursal || sucursalesDisponibles.length === 0) {
        return parseInt(window.localStorage.getItem("sucursalActual"));
    }

    return sucursal;
};
